import React, { useState } from 'react'
import {
  CAlert, CButton, CCard, CCardBody, CCol, CRow, CForm, CFormInput,
  CFormLabel, CTable, CTableHead, CTableRow, CTableHeaderCell, CTableBody,
  CTableDataCell, CSpinner,
} from '@coreui/react'
import { api, currentUser } from '../api/client'
import { fmtMoneda } from '../utils/moneda'

interface FilaUtilidad {
  fecha: string | null
  utilidad: number
}

/**
 * Utilidades — réplica de informeutilidadporfecha.cs (SiprinMax GX).
 * Título literal del GX. La utilidad por fecha es SUM(AbonoLibreValor1)
 * (utilidadbrutamesahoytotal.cs:150 — SELECT SUM([AbonoLibreValor1]) del
 * rango de fechas por empresa).
 */
const UtilidadesPage: React.FC = () => {
  const user = currentUser()
  const empresa = user?.companyId ?? ''
  const [desde, setDesde] = useState('')
  const [hasta, setHasta] = useState('')
  const [generando, setGenerando] = useState(false)
  const [filas, setFilas] = useState<FilaUtilidad[]>([])
  const [error, setError] = useState('')

  const generar = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setFilas([])
    if (!desde || !hasta) return

    setGenerando(true)
    try {
      const data = await api.get<FilaUtilidad[]>(
        `/reportes/utilidad-por-fecha?empresa=${encodeURIComponent(empresa)}&desde=${desde}&hasta=${hasta}`,
      )
      setFilas(data)
    } catch (err: any) {
      setError(err.message)
    } finally {
      setGenerando(false)
    }
  }

  const total = filas[filas.length - 1]
  const dias = total ? filas.slice(0, -1) : filas

  return (
    <>
      <CRow className="mb-4">
        <CCol>
          <h4>INFORME DE UTILIDAD SEGUN FECHA</h4>
        </CCol>
      </CRow>

      {error && <CAlert color="danger" dismissible onClose={() => setError('')}>{error}</CAlert>}

      <CCard className="mb-4">
        <CCardBody>
          <CForm onSubmit={generar}>
            <CRow className="g-3 align-items-end">
              <CCol md={4}>
                <CFormLabel>Fecha Inicial:</CFormLabel>
                <CFormInput type="date" value={desde} onChange={(e) => setDesde(e.target.value)} />
              </CCol>
              <CCol md={4}>
                <CFormLabel>Fecha Final:</CFormLabel>
                <CFormInput type="date" value={hasta} onChange={(e) => setHasta(e.target.value)} />
              </CCol>
              <CCol md={4}>
                <CButton color="primary" type="submit" disabled={generando}>
                  Generar Informe
                </CButton>
              </CCol>
            </CRow>
          </CForm>
        </CCardBody>
      </CCard>

      {generando && (
        <div className="text-center py-4">
          <CSpinner color="primary" />
        </div>
      )}

      {filas.length > 0 && (
        <CCard className="mb-4">
          <CCardBody>
            <CTable hover responsive striped>
              <CTableHead>
                <CTableRow>
                  <CTableHeaderCell>Fecha</CTableHeaderCell>
                  <CTableHeaderCell className="text-end">Utilidad</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {dias.map((fila, i) => (
                  <CTableRow key={i}>
                    <CTableDataCell>{fila.fecha ? String(fila.fecha).slice(0, 10) : ''}</CTableDataCell>
                    <CTableDataCell className="text-end">
                      {fmtMoneda(fila.utilidad)}
                    </CTableDataCell>
                  </CTableRow>
                ))}
                <CTableRow className="fw-semibold" style={{ background: 'var(--cui-tertiary-bg)' }}>
                  <CTableDataCell>TOTAL</CTableDataCell>
                  <CTableDataCell className="text-end">
                    {fmtMoneda(total?.utilidad)}
                  </CTableDataCell>
                </CTableRow>
              </CTableBody>
            </CTable>
          </CCardBody>
        </CCard>
      )}
    </>
  )
}

export default UtilidadesPage
